import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Username from "../pages/username";
import ThankYou from "../pages/ThankYou";
import MoreInfo from "../pages/MoreInfo";


const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/thank-you",
    element: <ThankYou />,
  },
  {
    path: "/moreinfo",
    element: <MoreInfo />,
  },
  {
    path: "/:refId",
    element: <Username />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
